import { AppSidebar } from "./AppSidebar";
import { TopBar } from "./TopBar";

export function AppShell({
  title,
  subtitle,
  actions,
  children,
}: {
  title: string;
  subtitle?: string;
  actions?: React.ReactNode;
  children: React.ReactNode;
}) {
  return (
    <div className="flex min-h-screen w-full bg-background text-foreground">
      <AppSidebar />
      <div className="flex-1 flex flex-col min-w-0">
        <TopBar title={title} subtitle={subtitle} actions={actions} />
        <main className="flex-1 px-3 md:px-5 lg:px-8 py-4 md:py-6">{children}</main>
      </div>
    </div>
  );
}
